import axios, { AxiosResponse } from 'axios'
import moment from 'moment'
import { TagawattChartData, TagawattChartParams } from './_models'
import { WithData } from '../../common/utils/axiosWithCSRF'

export function getChartData(
  date: Date | null = null,
  initTime: Date | null = null,
  endTime: Date | null = null
) {
  let url = `/lora_webhook/getChartData`
  if (date && initTime && endTime) {
    const dateConverted = moment(date)
    const dateFormatted = dateConverted.format('YYYY-MM-DD')

    const formattedInitTime = initTime?.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    })

    const formattedEndTime = endTime?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })

    const paramsArr = [
      `date=${dateFormatted}`,
      `initTime=${formattedInitTime}`,
      `endTime=${formattedEndTime}`,
    ]
    url = `/lora_webhook/getChartData?${paramsArr.filter(Boolean).join('&')}`
  }
  return axios
    .get(url)
    .then((response: AxiosResponse) => response.data)
    .then((response) => response.data)
}

function normalizeResponseData(resp: any) {
  if (Array.isArray(resp)) return resp
  if (resp && Array.isArray(resp.data)) return resp.data
  return resp
}

// Fetch chart data for a specific day with optional time window
export function getChartDataForDay(params: {
  deviceId?: string
  dateYmd: string // 'YYYY-MM-DD'
  initTimeHHmm?: string // 'HH:mm'
  endTimeHHmm?: string // 'HH:mm'
}) {
  const query: string[] = []
  if (params.deviceId) query.push(`device_id=${encodeURIComponent(params.deviceId)}`)
  if (params.dateYmd) query.push(`date=${encodeURIComponent(params.dateYmd)}`)
  if (params.initTimeHHmm) query.push(`initTime=${encodeURIComponent(params.initTimeHHmm)}`)
  if (params.endTimeHHmm) query.push(`endTime=${encodeURIComponent(params.endTimeHHmm)}`)

  const url = `/lora_webhook/getChartData${query.length ? `?${query.join('&')}` : ''}`

  return axios
    .get(url)
    .then((response: AxiosResponse) => response.data)
    .then((data) => normalizeResponseData(data) as Array<{ time: string; value: number }>)
}

export function liveDataChartApi(params: TagawattChartParams): Promise<TagawattChartData> {
  const paramsArr = [
    params.companyId && `company=${params.companyId}`,
    params.companySites && `company_sites=${encodeURIComponent(params.companySites)}`,
    params.meterType && `meter_type=${encodeURIComponent(params.meterType)}`,
    params.meterNumber && `meter_number=${encodeURIComponent(params.meterNumber)}`,
    params.chartType && `chart_type=${params.chartType}`,
    params.chartType === 'custom' &&
      params.customStartDate &&
      `start_date=${params.customStartDate}`,
    params.chartType === 'custom' && params.customEndDate && `end_date=${params.customEndDate}`,
    params.resolution && `resolution=${params.resolution}`,
  ]

  const url = `/readings_v2/chart?${paramsArr.filter(Boolean).join('&')}`

  return axios
    .get(url)
    .then((response: AxiosResponse<WithData<TagawattChartData>>) => response.data)
    .then((response) => response.data)
}
